import UserCreate from '../components/user/Create.vue';
import UserUpdate from '../components/user/Update.vue';
import UserValidationConfirmation from '../components/user/ValidationConfirmation.vue';
import UserValidationInfo from '../components/user/ValidationInfo.vue';
import PasswordRecovery from '../components/user/PasswordRecovery.vue';
import PasswordRecoveryToken from '../components/user/PasswordRecoveryToken.vue';
import auth from '../middleware/auth';

export default [
    {
        name: 'UserCreate',
        path: '/users/create',
        component: UserCreate,
        meta: {
            title: 'global.menu.register'
        }
    },
    {
        name: 'UserUpdate',
        path: '/users/edit',
        component: UserUpdate,
        meta: {
            middleware: [auth],
            title: 'global.menu.settings'
        }
    },
    {
        name: 'UserValidationConfirmation',
        path: '/users/validation/confirmation',
        component: UserValidationConfirmation,
        meta: {
            title: 'global.menu.register'
        }
    },
    {
        name: 'UserValidationInfo',
        path: '/users/validation/info',
        component: UserValidationInfo,
        meta: {
            title: 'global.menu.settings'
        }

    },
    {
        name: 'PasswordRecovery',
        path: '/users/password-recovery',
        component: PasswordRecovery,
        meta: {
            title: 'global.menu.settings'
        }
    },
    {
        name: 'PasswordRecoveryWithToken',
        path: '/users/password-recovery/:token',
        component: PasswordRecoveryToken,
        meta: {
            title: 'global.menu.settings'
        }
    },
];



// WEBPACK FOOTER //
// ./src/routes/user.js